import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
/**
 * Singleton to bridge RQ and view-states/stores.
 *
 * Under tests. DO NOT USE THIS. If you plan on using this, please talk to @tiba first.
 */ export var ReactQueryClientStore__DO_NOT_USE = /*#__PURE__*/ function() {
    "use strict";
    function ReactQueryClientStore__DO_NOT_USE() {
        var _this = this;
        _class_call_check(this, ReactQueryClientStore__DO_NOT_USE);
        this.setClient = function(client) {
            _this._client = client;
        };
    }
    _create_class(ReactQueryClientStore__DO_NOT_USE, [
        {
            key: "client",
            get: /**
     * ReactQuery client getter. Throws if not set, which will happen if you try to use this
     * before the React tree is rendered (for instance, app initializers should not use this store).
     *
     * If you're using this, please talk to @tiba first.
     */ function get() {
                if (!this._client) {
                    throw new Error("ReactQueryClientStore: client not set");
                }
                return this._client;
            }
        }
    ]);
    return ReactQueryClientStore__DO_NOT_USE;
}();
ReactQueryClientStore__DO_NOT_USE.get = singletonGetter(ReactQueryClientStore__DO_NOT_USE);
/**
 * Small component to configure the query client in ReactQueryClientStore.
 *
 * Once we have concluded the tests, we will merge this into QueryClientProvider
 * from web/common/reactQuery
 */ export var ReactQueryClientStoreProvider = function(param) {
    var children = param.children;
    var client = useQueryClient();
    useEffect(function() {
        ReactQueryClientStore__DO_NOT_USE.get().setClient(client);
    }, [
        client
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
